import React from 'react';
import CheckboxGroup from '../../../controls/CheckboxGroup';
import EntityField from '../internal/EntityField';
const CheckboxGroupField = ({ isDisabled = false, inline = false, options, ...rest }) => (<EntityField {...rest}>
    {(isEditing, { input: { value, onChange, ...restInput }, meta: { submitting, touched, submitFailed, error }, ...field }) => (<CheckboxGroup {...field} errorMessage={touched || submitFailed ? error : undefined} inline={inline} inputProps={restInput} isDisabled={isDisabled || !isEditing || submitting} options={options} value={value || []} onChange={onChange}/>)}
  </EntityField>);
export default CheckboxGroupField;
